import StateManager from 'Apollo/StateManager';
import { HeroMediaParams, QualityOptions } from 'generated/graphql';

const stateManager = new StateManager('showroom.userView.share');

export const setDialogIsOpen = (isDialogOpen: boolean) => {
	stateManager.update({ isDialogOpen });
};

export const setShowroomShareMediaQuality = (mediaQuality: QualityOptions) => {
	stateManager.update({ mediaQuality });
};

export const getHeroMediaParamsFromHeroMedia = (heroMedia): Partial<HeroMediaParams> => {
	return {
		mediaType: heroMedia.mediaType,
		publicId: heroMedia.publicId,
		publicUrl: heroMedia.publicUrl
	};
};
